import React, { createContext } from "react";

const initialState = {
  theme: null,
  syndicat: null,
  isInit: false,
  openedFilter: null,
  visibility: true,
};

const filterReducer = (state, action) => {
  switch (action.type) {
    case "SET_THEME_FILTER":
      return {
        ...state,
        theme: action.theme,
        syndicat: null,
        isInit: true,
        openedFilter: null,
      };
    case "SET_OPENED_FILTER":
      return {
        ...state,
        openedFilter: action.openedFilter,
      };
    case "SET_SYNDICAT_FILTER": {
      return {
        ...state,
        syndicat: action.syndicat,
        theme: null,
        isInit: true,
        openedFilter: null,
      };
    }
    case "TOGGLE_FILTERS_VISIBILITY": {
      return {
        ...state,
        openedFilter: null,
        visibility: action.visibility,
      };
    }
    case "RESET_FILTERS": {
      return {
        ...initialState,
        isInit: true,
      };
    }
    default:
      return state;
  }
};
export const FilterContext = createContext();

export const FilterContextProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(filterReducer, initialState);
  const value = {
    filters: state,
    setTheme: (theme) => {
      dispatch({ type: "SET_THEME_FILTER", theme });
    },
    setSyndicat: (syndicat) => {
      dispatch({ type: "SET_SYNDICAT_FILTER", syndicat });
    },
    setOpenedFilter: (openedFilter) => {
      dispatch({ type: "SET_OPENED_FILTER", openedFilter });
    },
    toggleFilters: (visibility) => {
      dispatch({ type: "TOGGLE_FILTERS_VISIBILITY", visibility });
    },
    resetFilters: () => {
      dispatch({ type: "RESET_FILTERS" });
    },
  };

  return (
    <FilterContext.Provider value={value}>{children}</FilterContext.Provider>
  );
};

// export const FilterContextProvider = FilterContext.Provider;
